import { DEFAULT_LOCALE } from '@/lib/siteI18n';

const LOCALIZED_SLUGS = {
  de: {
    export: ['txt', 'docx', 'pdf', 'srt', 'vtt'],
    compare: ['vtt-vs-srt', 'vtt-vs-docx', 'srt-vs-vtt-vs-txt', 'docx-vs-pdf', 'txt-vs-docx'],
    transcribe: [
      'mp3-to-text',
      'm4a-to-text',
      'wav-to-text',
      'flac-to-text',
      'ogg-to-text',
      'aiff-to-text',
      'mp4-to-text',
      'mov-to-text',
    ],
    features: ['record-tab-audio', 'record-microphone', 'transcribe-from-url', 'youtube-caption-import'],
  },
  fr: {
    export: ['txt', 'docx', 'pdf', 'srt', 'vtt'],
    compare: ['vtt-vs-srt', 'vtt-vs-docx', 'srt-vs-vtt-vs-txt', 'docx-vs-pdf', 'txt-vs-docx'],
    transcribe: [
      'mp3-to-text',
      'm4a-to-text',
      'wav-to-text',
      'flac-to-text',
      'ogg-to-text',
      'aiff-to-text',
      'mp4-to-text',
      'mov-to-text',
    ],
    features: ['record-tab-audio', 'record-microphone', 'transcribe-from-url', 'youtube-caption-import'],
  },
};

export function hasLocalizedPseoPath(path, locale) {
  if (!locale || locale === DEFAULT_LOCALE) return true;

  const [section, slug, ...rest] = String(path || '/')
    .split(/[?#]/, 1)[0]
    .split('/')
    .filter(Boolean);

  if (!slug) return true;
  if (rest.length > 0) return false;

  if (!LOCALIZED_SLUGS[locale] || !LOCALIZED_SLUGS[locale][section]) return true;
  return LOCALIZED_SLUGS[locale][section].includes(slug);
}
